/* global angular, mintel_tracking */

var ngModule = angular.module('trends');

ngModule.service('MixpanelAdvancedSearch', ['HistoricContext',
    function(HistoricContext) {
        this.advancedSearch = function(filterName, filterType, tab) {
            var advancedSearchProps = {
                Criteria: [''],
                Filter: true,
                Keyword: '',
                'Search Filter Type': filterType,
                'Search Filter Name': filterName,
                Tab: tab
            };
            if (filterType !== null && filterType.length !== 0) {
                mintel_tracking.search('Advanced', advancedSearchProps);
            }
        };

        this.clearSearchFilter = function() {
            HistoricContext.insert('search_filter_type_context', [], 'session');
            HistoricContext.insert('search_filter_name_context', [], 'session');
            HistoricContext.save();
        };
    }
]);

ngModule.directive('trackingViewContent',
    function () {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs) {
               mintel_tracking.view('Content', {
                   'Title': attrs.mainTitle,
                   'Content Type': attrs.type,
                   'Content Unique Identifier': attrs.itemId,
                   'Tags': [],
                   'Author': '',
                   'Display Date': attrs.displayDate,
                   'Slug': '',
               });
            }
        };
    }
);

ngModule.directive('trackingExploreAdvancedSearch', ['Input', 'HistoricContext', 'MixpanelAdvancedSearch',
    function (Input, HistoricContext, MixpanelAdvancedSearch) {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs) {
                var key = attrs.key;

                Input.addAccessibleClickHandler(element, function () {

                    // Mixpanel API call once click filters on Explore tab
                    var hselectVal = HistoricContext.getValue('hselect');

                    // Filter the condition if user click on the same filter several times.
                    if (key !== hselectVal) {
                        var filterType = [];
                        filterType.push(key.charAt(0).toUpperCase() +
                                key.substring(1, key.length));
                        MixpanelAdvancedSearch.advancedSearch('', filterType, 'Explore');
                    }
                });
            }
        };
    }]);

// Event done by clicking the content and sent Mixpanel.
ngModule.directive('trackingClickContext', ['Input', 'HistoricContext', 'MixpanelAdvancedSearch',
    function (Input, HistoricContext, MixpanelAdvancedSearch) {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element) {
                Input.addAccessibleClickHandler(element, function () {
                    var selectedTab = HistoricContext.getValue('category_selection');
                    var filterName = HistoricContext.getValue('search_filter_name_context');
                    var filterType = HistoricContext.getValue('search_filter_type_context');
                    var tab = 'Observations';

                    if (selectedTab !== null && selectedTab !== 'group') {
                        tab = selectedTab.charAt(0).toUpperCase() +
                            selectedTab.substring(1, selectedTab.length) + 's';
                        MixpanelAdvancedSearch.advancedSearch(filterName, filterType, tab);
                        MixpanelAdvancedSearch.clearSearchFilter();
                    }
                });
            }
        };
    }]);
